import { Component, ElementRef, HostListener, Input, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { fadeIn, fadeInOut } from '../animations';
import { ChatService } from '../chatbot-rasa.service';
import { Person } from '../types/Person';
import {UserService} from '../../../public/onboarding/services/user.service';
import {KeycloakService} from "keycloak-angular";

const rand = max => Math.floor(Math.random() * max);

@Component({
  selector: 'chat-widget',
  templateUrl: './chat-widget.component.html',
  styleUrls: ['./chat-widget.component.css'],
  animations: [fadeInOut, fadeIn],
})
export class ChatWidgetComponent implements OnInit {
  @ViewChild('bottom') bottom: ElementRef;
  @Input() public theme: 'blue' | 'grey' | 'red' = 'blue';
  @Input() public botName = 'Eva';
  @Input() public botAvatar = `../../../../assets/images/chatbot_eva.png`;
  @Input() public userAvatar = `../../../../assets/images/chatUser.png`;
  @Input() public url;
  @Input() public opened = true;
  @Input() public session = null;

  public _visible = false;

  private chatService: ChatService;
  private userService: UserService;
  private keycloakService: KeycloakService;

  constructor(chatService: ChatService, userService: UserService, keycloakService: KeycloakService) {
    this.chatService = chatService;
    this.userService = userService;
    this.keycloakService = keycloakService;
  }

  public get visible() {
    return this._visible;
  }

  @Input()
  public set visible(visible) {
    this._visible = visible;
    if (this._visible) {
      setTimeout(() => {
        this.scrollToBottom();
        this.focusMessage();
      }, 0);
    }
  }

  public focus = new Subject();

  public operator = new Person();

  public client = new Person();

  public messages = [];

  public addMessage(from, text, type: 'received' | 'sent', hasButtons?, buttons?) {
    this.messages.unshift({
      from,
      text,
      type,
      date: new Date().getTime(),
      hasButtons,
      buttons
    });
    this.scrollToBottom();
  }

  public scrollToBottom() {
    if(this.bottom){
      this.bottom.nativeElement.scrollTop = this.bottom.nativeElement.scrollHeight;
    }
  }

  public focusMessage() {
    this.focus.next(true);
  }

  async ngOnInit() {
    if (!this.url) {
      throw Error('URL-ul nu este valid');
    }

    // this.keycloakService.isLoggedIn()
    //   .then( (data) => {
    //
    //     if (data){
    //       this.client = {
    //         name: 'Guest User',
    //         status: 'offline',
    //         avatar: this.userAvatar,
    //       };
    //
    //       this.operator = {
    //         name: this.botName,
    //         status: 'online',
    //         avatar: this.botAvatar,
    //       };
    //
    //     }else {
          this.chatService.connect(this.url, this.session, this.setStatus.bind(this));

          this.client = {
            name: 'Guest User',
            status: 'offline',
            avatar: this.userAvatar,
          };


          this.operator = {
            name: this.botName,
            status: 'offline',
            avatar: this.botAvatar,
          };
          if (this.opened) {
            setTimeout(() => this.visible = true, 1000);
          }
          // setTimeout(() => {
          //   this.addMessage(this.operator, this.startingMessage, 'received')
          // }, 1500)
          this.chatService
            .getMessages()
            .subscribe((message) => {
              if(message.quick_replies){
                this.addMessage(this.operator, message.text, 'received');
                this.addMessage(this.operator, null, 'received', true, message.quick_replies);
              }else{
                this.addMessage(this.operator, message.text, 'received');
              }

            });
        // }
    // });

  }

  public setStatus(status: boolean) {
    this.operator.status = status ? 'online' : 'offline';
  }

  public toggleChat() {
    this.visible = !this.visible;
  }

  public async sendMessage({message}) {
    if (message.trim() === '') {
      return;
    }

    this.addMessage(this.client, message, 'sent');

    // this.keycloakService.isLoggedIn()
    //   .then( async (data) => {
        // if (data) {
          // tslint:disable-next-line:no-shadowed-variable
          // const res =  this.chatService.postChatMessage(message).subscribe(res => {
          //   console.log(res)
          // });
          // this.chatbotService.callChatbot('test').subscribe(answer => {
          //   console.log('CHATBOT : ', answer);
          // });
          // this.addMessage(this.operator, res, 'received');
        // }else {
    this.chatService.sendMessage(message);
        // }

      // });
  }

  public callButtonAction(internalMessage){
    this.chatService.sendMessage(internalMessage);
  }

  public clear() {
    this.sendMessage({message: '666'});
    this.messages = [];
  }

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === '/') {
      this.focusMessage();
    }
    if (event.key === '?' && !this._visible) {
      this.toggleChat();
    }
  }

}
